import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  TextField,
  Typography,
} from '@mui/material';
import { checkBoxitem, hotelBoardTypes, hotelCategories } from 'src/constants';
import { FormSecondStep } from './FormSecondStep';
import { FormFirstStep } from './FormFirtsStep';
import { FormThirdstep } from './FormThirdstep';
import { DialogFormSubmitButton } from './DialogFormSubmitButton';
import { useEffect } from 'react';

export const DialogForm = ({
  questionnaireData,
  flightsOptions,
  destinations,
  handleCheckboxChange,
  setQuestionnaireData,
  setFlightsOptions,
  handleQuestionnaireSubmit,
  handleClose,
  roomsData,
  setRoomsData,
}) => {
  const [checkBoxItemState, setCheckBoxItemState] = useState(checkBoxitem);

  const handleChange = (value) => {
    handleCheckboxChange(value);
    setCheckBoxItemState((prevState) =>
      prevState.map((item) => (item.value === value ? { ...item, checked: !item.checked } : item))
    );
  };

  const [formStep, setFormStep] = useState(1);

  return (
    <DialogContent
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        gap: '1rem',
        padding: '1rem',
      }}
    >
      {formStep === 1 && (
        <>
          <Typography
            sx={{
              marginTop: '5px',
              textAlign: 'center',
              padding: '0 1rem',
            }}
            variant="h4"
          >
            Please select the services you would like to include in your booking package:
          </Typography>
          <FormFirstStep
            checkBoxitemState={checkBoxItemState}
            questionnaireData={questionnaireData}
            hotelCategories={hotelCategories}
            hotelBoardTypes={hotelBoardTypes}
            handleChange={handleChange}
            setQuestionnaireData={setQuestionnaireData}
          />
        </>
      )}
      {formStep === 2 && questionnaireData?.preferences?.hotel && (
        <>
          {!!roomsData && (
            <>
              <Typography
                sx={{
                  marginTop: '5px',
                  textAlign: 'center',
                  padding: '0 1rem',
                }}
                variant="h4"
              >
                Select Passengers
              </Typography>
              <PassengersFormStep
                roomsData={roomsData}
                setRoomsData={setRoomsData}
                setFlightsOptions={setFlightsOptions}
              />
              <Divider sx={{ my: 2, width: '100%' }} />
            </>
          )}
          <Typography sx={{ marginTop: '5px' }}>
            Please choose your preferred hotel Category
          </Typography>

          <FormSecondStep
            ratingValue={questionnaireData.hotelCategory}
            setRatingValue={(value) =>
              setQuestionnaireData({
                ...questionnaireData,
                minHotelCategory: value,
                hotelCategory: value,
                maxHotelCategory: value,
              })
            }
          />
        </>
      )}

      {formStep === 2 && !questionnaireData?.preferences?.hotel && (
        <>
          <Typography sx={{ marginTop: '5px' }}>
            <h1 className="text-lg sm:text-2xl">You are all set!</h1>
          </Typography>
        </>
      )}

      {formStep === 3 && questionnaireData.preferences.flights && (
        <>
          <Typography sx={{ marginTop: '5px' }}>
            <h1 className="text-lg sm:text-2xl">Please Enter the Flight Details</h1>
          </Typography>
          <FormThirdstep
            destinations={destinations}
            flightsOptions={flightsOptions}
            setFlightsOptions={setFlightsOptions}
            setQuestionnaireData={setQuestionnaireData}
            questionnaireData={questionnaireData}
          />
        </>
      )}

      <DialogActions
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          // padding: 0,
        }}
        className="p-[0!important] sm:p-[24px!important]"
      >
        {formStep === 2 && questionnaireData.preferences.flights && (
          <>
            <Button
              sx={{
                width: '50%',
              }}
              variant="contained"
              color="grey"
              onClick={() => setFormStep(1)}
            >
              Go back
            </Button>
          </>
        )}
        <DialogFormSubmitButton
          departureCity={flightsOptions.departureCity}
          formStep={formStep}
          setFormStep={setFormStep}
          handleClose={handleClose}
          needsForFlights={questionnaireData.preferences.flights}
          needsForHotels={questionnaireData.preferences.hotel}
          handleQuestionnaireSubmit={handleQuestionnaireSubmit}
        />
      </DialogActions>
    </DialogContent>
  );
};

DialogForm.propTypes = {
  questionnaireData: PropTypes.object,
  handleCheckboxChange: PropTypes.func,
  destinations: PropTypes.array,
  flightsOptions: PropTypes.object,
  setQuestionnaireData: PropTypes.func,
  handleQuestionnaireSubmit: PropTypes.func,
  handleClose: PropTypes.func,
  setFlightsOptions: PropTypes.func,
};

export default DialogForm;

function PassengersFormStep({ roomsData, setRoomsData, setFlightsOptions }) {
  const handleChangeAdults = (roomIndex, value) => {
    if (value < 1) return;
    setRoomsData((prev) =>
      prev.map((r, i) => {
        if (i === roomIndex) {
          const total = r.kids + value;
          if (total > 8) return r;
          return { ...r, adults: value };
        }
        return r;
      })
    );
  };
  const handleChangeKids = (roomIndex, value) => {
    if (value < 0) return;
    setRoomsData((prev) =>
      prev.map((r, i) => {
        if (i === roomIndex) {
          const total = r.adults + value;
          if (total > 8) return r;
          if (r.childrenAges.length > value) {
            return {
              ...r,
              kids: value,
              childrenAges: r.childrenAges.slice(0, value),
            };
          } else {
            return {
              ...r,
              kids: value,
              childrenAges: r.childrenAges.concat(Array(value).fill(0)).slice(0, value),
            };
          }
        }
        return r;
      })
    );
  };
  const handleChangeChildrenAges = (roomIndex, childIndex, value) => {
    if (value < 0) return;
    setRoomsData((prev) =>
      prev.map((r, i) => {
        if (i === roomIndex) {
          const ages = [...r.childrenAges];
          ages[childIndex] = value;
          return {
            ...r,
            childrenAges: ages,
          };
        }
        return r;
      })
    );
  };
  const handleAddRoom = () => {
    setRoomsData((prev) =>
      prev.concat({
        adults: 1,
        kids: 0,
        childrenAges: [],
      })
    );
  };
  const handleRemoveRoom = (roomIndex) => {
    setRoomsData((prev) => prev.filter((_, i) => i !== roomIndex));
  };

  useEffect(() => {
    if (!roomsData) return;
    const timeout = setTimeout(() => {
      const { adults, child, infants } = roomsData.reduce(
        (acc, curr) => {
          acc.adults += curr.adults;
          curr.childrenAges.forEach((age) => {
            if (age < 2) {
              acc.infants++;
            } else {
              acc.child++;
            }
          });
          return acc;
        },
        {
          adults: 0,
          child: 0,
          infants: 0,
        }
      );
      setFlightsOptions((prev) => ({
        ...prev,
        passangers: { adults, child, infants },
      }));
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [roomsData]);
  return (
    <ul>
      {roomsData.map((room, index) => (
        <li key={index}>
          <Typography variant="h6">{`Room ${index + 1}: `}</Typography>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <TextField
              margin="dense"
              type="number"
              label="Adults"
              value={room.adults}
              min={1}
              max={8}
              onChange={(e) => handleChangeAdults(index, Number(e.target.value))}
            />
            <TextField
              margin="dense"
              type="number"
              label="Kids"
              value={room.kids}
              min={0}
              max={4}
              onChange={(e) => handleChangeKids(index, Number(e.target.value))}
            />
            {room.kids > 0 &&
              Array(room.kids)
                .fill(0)
                .map((_, chIndex) => (
                  <TextField
                    margin="dense"
                    key={chIndex}
                    type="number"
                    label={`Child ${chIndex} Age`}
                    value={room.childrenAges[chIndex] ?? 0}
                    min={0}
                    max={17}
                    onChange={(e) =>
                      handleChangeChildrenAges(index, chIndex, Number(e.target.value))
                    }
                  />
                ))}
          </div>
          {roomsData.length > 1 && (
            <div className="w-full flex justify-end mt-1">
              <Button
                type="button"
                size="small"
                variant="contained"
                color="error"
                onClick={() => handleRemoveRoom(index)}
              >
                Remove Room
              </Button>
            </div>
          )}
        </li>
      ))}
      <footer className="w-full mt-2">
        {roomsData.length < 4 && (
          <Button type="button" size="small" variant="contained" onClick={handleAddRoom}>
            Add Room
          </Button>
        )}
      </footer>
    </ul>
  );
}
